<crm-single-select
  [options]="converters"
  [(selectedItem)]="selectedConverter"
  (selectedItemChange)="selectedConverterChange.emit($event)"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [label]="isFloatLabel ? 'Конвертер' : ''"
  [placeholder]="placeholder"
  [sort]="sort"
  [showClear]="showClear"
  [appendTo]="appendTo"
  [disabled]="disabled">
</crm-single-select>
